import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/contactus.scss";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsSubmitting(true);
    setTimeout(() => {
      setShowSuccess(true);
      setFormData({ name: "", email: "", message: "" });
      setIsSubmitting(false);
      setTimeout(() => setShowSuccess(false), 5000);
    }, 1000);
  };
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="contact-page">
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <Link to="/" onClick={toTop}>
            Home
          </Link>
          <span className="separator"></span>
          <span className="current">Contact us</span>
        </nav>

        {/* Header Section */}
        <header className="contact-header">
          <h1>Contact us</h1>
          <p className="intro">
            Have a question or feedback for us? We've a number of ways for you
            to reach out.
          </p>

          <ul className="contact-methods">
            <li>
              <span className="emoji">✍️</span>
              <span>
                Fill in the form <a href="#contact-form">below</a> – we'll do
                our best to get back to you within 2 business days.
              </span>
            </li>
            <li>
              <span className="emoji">📧</span>
              <span>
                Send your questions to{" "}
                <a href="mailto:draft@pedarcircle.club">
                  draft@pedarcircle.club
                </a>
              </span>
            </li>
            <li>
              <span className="emoji">⚒️</span>
              <span>
                Work in the interior design or construction industries? Email us
                at{" "}
                <a href="mailto:draft@pedarcircle.club">
                  draft@pedarcircle.club
                </a>{" "}
                with your trade query.
              </span>
            </li>
            <li>
              <span className="emoji">🌍</span>
              <span>
                If you've questions or advice relating to our environmental
                impact, drop us a line at{" "}
                <a href="mailto:draft@pedarcircle.club">
                  draft@pedarcircle.club
                </a>
              </span>
            </li>
            <li>
              <span className="emoji">💡</span>
              <span>
                If you'd like to share partnership ideas with our marketing
                team, email{" "}
                <a href="mailto:draft@pedarcircle.club">
                  draft@pedarcircle.club
                </a>
              </span>
            </li>
            <li>
              <span className="emoji">💬</span>
              <span>
                For all other enquiries, email {" "}
                <a href="mailto:draft@pedarcircle.club">
                  draft@pedarcircle.club
                </a>
                .
              </span>
            </li>
          </ul>
        </header>

        {/* Form Section */}
        <section id="contact-form" className="form-section">
          <h2>Contact Form</h2>

          {showSuccess && (
            <div className="success-message">
              Thank you! Your message has been sent successfully.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className={`form-group ${errors.name ? "has-error" : ""}`}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
                {errors.name && (
                  <span className="error-text">{errors.name}</span>
                )}
              </div>

              <div className={`form-group ${errors.email ? "has-error" : ""}`}>
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                {errors.email && (
                  <span className="error-text">{errors.email}</span>
                )}
              </div>
            </div>

            <div
              className={`form-group full-width ${
                errors.message ? "has-error" : ""
              }`}
            >
              <label htmlFor="message">Your message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Your message"
                rows="6"
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>
              {errors.message && (
                <span className="error-text">{errors.message}</span>
              )}
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Now"}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}

export default Contact;
